import mbcService from '@/services/mbcService';
import ssoService from '@/services/ssoService';
import actService from '@/services/actService';
import comService from '@/services/comService';

export default {
  namespaced: true,
  state: {
    memberType: null,
    memberData: null,
    memberId: '',
    code: '',
  },
  mutations: {
    set(state, { name, value }) {
      state[name] = value;
    },
    push(state, { name, value }) {
      state[name].push(value);
    },
    delete(state, { name }) {
      state[name] = null;
    },
  },
  actions: {
    // 取得會籍資料
    getMemberType: ({ state, commit, rootState }) => {
      // 若state中沒有會籍資料的promise，呼叫API
      if (!state.memberType) {
        const body = { companyId: rootState.companyId };
        const headers = { accessToken: rootState.accessToken };
        const memberType = ssoService.getDigest(rootState.companyId, rootState.memberSourceId, body)
          .toPromise()
          .then((res) => {
            headers.digest = res.response.data[0].digest;
            return mbcService.getMemberType(body, headers).toPromise();
          })
          .then((res) => ({
            currentLevelId: res.response.data[0].memberTypeID,
            currentLevel: res.response.data[0].memberTypeName,
            nextLevel: res.response.data[0].upgMemberTypeName,
            currentAmount: res.response.data[0].totalAmount,
            upgradeAmount: res.response.data[0].upgAmount,
            cardPic: res.response.data[0].cardPic,
            iconPic: res.response.data[0].iconPic,
            barcodeSource: res.response.data[0].barcodeSource,
            qrcodeSource: res.response.data[0].qrcodeSource,
          }));
        commit('set', { name: 'memberType', value: memberType });
      }

      // 若state中已有會籍資料的promise，直接回傳
      return state.memberType;
    },
    // 取得會員資料
    getMemberData: ({ state, commit, rootState }) => {
      // 若state中沒有會員資料的promise，呼叫API
      if (!state.memberData) {
        const body = { companyId: rootState.companyId };
        const headers = { accessToken: rootState.accessToken };
        const memberData = ssoService.getDigest(state.companyId, rootState.memberSourceId, body)
          .toPromise()
          .then((res) => {
            headers.digest = res.response.data[0].digest;
            return mbcService.getCustomerData(body, headers).toPromise();
          })
          .then((res) => ({
            name: res.response.data[0].name,
            endTime: res.response.data[0].endTime,
          }));
        commit('set', { name: 'memberData', value: memberData });
      }

      // 若state中已有會員資料的promise，直接回傳
      return state.memberData;
    },
    getAccountVerifier({ rootState }, payload) {
      const params = {
        companyID: rootState.companyId,
        accountID: payload,
      };
      return mbcService.getAccountVerifier(params).toPromise();
    },
    getCustomer({ rootState }) {
      const body = {
        companyId: rootState.companyId,
        memberID: rootState.memberId,
        memberSourceID: rootState.memberSourceId,
      };
      return mbcService.getCustomer(body).toPromise();
    },
    postCustomerdataadd({ rootState }, payload) {
      const body = {
        companyID: rootState.companyId,
        memberSourceID: rootState.memberSourceId,
        accountType: payload.accountType,
        identifySource: payload.accountId,
        accountID: payload.accountId,
        callingCode: payload.callingCode,
        mobile: payload.mobile,
        mobileCountry: payload.mobileCountry,
        name: payload.accountId,
        verify: true,
        recommendId: rootState.memberId,
        recommendSource: payload.no,
        activate: true,
      };
      return ssoService.getDigest(rootState.companyId, rootState.memberSourceId, body)
        .toPromise()
        .then((res) => {
          const header = { digest: res.response.data[0].digest };
          return mbcService.postCustomerdataadd(body, header).toPromise().then((r) => r.response).catch((err) => err);
        }).catch((err) => err);
    },
    getMemberAccount({ rootState }, payload = {}) {
      const params = {
        companyId: rootState.companyId,
        memberSourceId: rootState.memberSourceId,
        accountID: payload.accountId,
      };

      return mbcService.getMemberAccount(params)
        .toPromise().then((res) => res.response).catch((err) => err);
    },
    postCustomerdatabind({ rootState }, payload = {}) {
      const body = {
        companyId: rootState.companyId,
        memberSourceId: rootState.memberSourceId,
        openID: payload.openId,
        accountType: payload.type,
        identifySource: payload.identifySource,
        memberID: payload.memberId,
      };

      return mbcService.postCustomerdatabind(body).toPromise().then((res) => res.response).catch((err) => err);
    },
    postMGMActivity({ rootState }, payload = {}) {
      const body = {
        language: navigator.language.toLowerCase(),
        activity: [
          {
            activityId: rootState.activityId,
            mgm: [
              {
                mgmType: payload.mgmType,
                member: [
                  {
                    sourceMemberId: rootState.memberId,
                    memberId: payload.memberId,
                  },
                ],
              },
            ],
          },
        ],
      };

      return actService.postMGMActivity(body).toPromise().then((res) => res.response).catch((err) => err);
    },
    postLINEUserId({ rootState }, payload = {}) {
      const body = {
        code: payload.code,
        companyId: rootState.companyId,
        directURL: payload.directURL,
      };

      return comService.postLINEUserId(body).toPromise().then((res) => res.response).catch((err) => err);
    },
    postMemberProspectiveCustomerRelease(_, payload = {}) {
      const body = {
        accountId: payload.accountId,
        accountType: payload.accountType,
      };

      return mbcService.postMemberProspectiveCustomerRelease(body).toPromise().then((res) => res.response).catch((err) => err);
    },
  },
};
